import YFormMultiPickList from './MultiPickList';

export { YFormMultiPickList };
export default YFormMultiPickList;
